export default __webpack_public_path__ + "static/media/dinersclub.d4f22386.svg";